/**
 * Created by neo on 02.12.20.
 *
 * Plain TypeScript type - no MobX observables.
 */
import { WeekDayEntryBase, parseWeekDayEntry } from './WeekDayEntry';
import {
  MindfulnessProgramWeekUnit,
  createMindfulnessProgramWeekUnit,
} from '../Mindfulness/MindfulnessProgramWeekUnit';

export type WeekDayEntryMindfulnessUnit = WeekDayEntryBase & {
  type: 'mindfulnessUnit';
  unit: MindfulnessProgramWeekUnit;
};

export function parseWeekDayEntryMindfulnessUnit(json?: any): WeekDayEntryMindfulnessUnit {
  return {
    ...parseWeekDayEntry({ ...json, type: 'mindfulnessUnit' }),
    type: 'mindfulnessUnit' as const,
    unit: createMindfulnessProgramWeekUnit(json?.unit),
  };
}

/** @deprecated Use parseWeekDayEntryMindfulnessUnit instead */
export const createWeekDayEntryMindfulnessUnit = parseWeekDayEntryMindfulnessUnit;
